import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { People, Warning } from '../../../ui/icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useTranslationService } from '../../../utils/translate';

const Overview = ({ course }) => {
    const { t, i18n } = useTranslation();
    const { translateText } = useTranslationService();
    const [translatedData, setTranslatedData] = useState({
        description: '',
        loading: false,
        error: null
    });

    useEffect(() => {
        const translateCourseData = async () => {
            if (!course) return;
            
            setTranslatedData(prev => ({ ...prev, loading: true, error: null }));
            
            try {
                const shouldTranslate = i18n.language !== 'en';
                
                const description = shouldTranslate 
                    ? await translateText(course.course_description)
                    : course.course_description;

                setTranslatedData({
                    description,
                    loading: false,
                    error: null
                });
            } catch (error) {
                setTranslatedData({
                    description: course.course_description,
                    loading: false,
                    error: error.message
                });
            }
        };

        translateCourseData();
    }, [course, i18n.language]);

    const cards = [
        {
            title: t('course.1.books.book1.title'),
            img: '/images/AboutCourse/Card.png',
            location: t('course.1.books.book1.author'),
            link: "https://www.amazon.com/International-Arbitration-Practice-Gary-Born-dp-940353253X/dp/940353253X/ref=dp_ob_image_bk"
        },
        {
            title: t('course.1.books.book2.title'),
            img: '/images/AboutCourse/Card2.png',
            location: t('course.1.books.book2.author'),
            link: "https://www.amazon.com/Concise-International-Arbitration-Loukas-Mistelis/dp/9041159681"
        },
        {
            title: t('course.1.books.book3.title'),
            img: '/images/AboutCourse/Card4.png',
            location: t('course.1.books.book3.author'),
            link: "https://www.amazon.com/Idea-Arbitration-Clarendon-Law/dp/0199564175/ref=sr_1_1?crid=3TGRM9EMPYANC&dib=eyJ2IjoiMSJ9.CUEcQtkqUf3vfgKoQTRROA.nIMhqJHPXmdckDOzq9i4UPpiHNyZZRizKiwTt9Oyqzo&dib_tag=se&keywords=paulsson+the+idea+of+arbitration&qid=1752828644&s=books&sprefix=paulsson+the+idea+of+arbitration%2Cstripbooks-intl-ship%2C265&sr=1-1"
        },
        {
            title: "Redfern and Hunter on International Arbitration",
            img: 'https://m.media-amazon.com/images/I/41gBxCM5HDL._SY425_.jpg',
            location: "Nigel Blackaby KC, Constantine Partasides KC. Alan Redfern",
            link: "https://www.amazon.com/Redfern-Hunter-International-Arbitration-Blackaby-dp-0192869906/dp/0192869906/ref=dp_ob_title_bk"
        },
    ];

    return (
        <div className="course-overview">

            <div className='lg:flex sm:flex justify-between'>
                <h2 className='uppercase font-normal text-[#1E1E1E] text-lg sm:text-base'>
                    {t('course.1.description.title')}
                </h2>
                <div className='w-[100%] sm:w-[65%] text-[#5c5c5c]'>
                    {translatedData.loading ? (
                        <p className="text-gray-500">{t('common.translating')}</p>
                    ) : translatedData.error ? (
                        <p className="text-red-500">
                            {t('common.translation_error')}: {translatedData.error}
                        </p>
                    ) : (
                        <p>{translatedData.description || course?.course_description}</p>
                    )}
                </div>
            </div>

            <div className='pt-6'>
                <h2 className='uppercase font-normal text-[#1E1E1E]'>
                    {t('course.1.reading.title')}
                </h2>
                <p className='text-[#5C5C5C] pt-4 pb-2'>
                    {t('course.1.reading.recommendation')}
                </p>
                <div className='flex'>
                    <Swiper
                        slidesPerView={4}
                        spaceBetween={5}
                        breakpoints={{
                            0: { slidesPerView: 2.1 },
                            768: { slidesPerView: 4 }
                        }}
                    >
                        {cards.map((card, index) => (
                            <SwiperSlide key={index} className='cursor-pointer'>
                                <a className="pr-4" target='_blank' rel="noopener noreferrer" href={card.link}>
                                    <img src={card.img} alt={card.title} className="w-full"/>
                                    <h4 className="font-semibold mt-2">{card.title}</h4>
                                    <p className="text-[#1E1E1E] opacity-80 pt-1 text-[16px]">{card.location}</p>
                                </a>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    );
};

export default Overview;